/**
 * This file exists as a FE map for BE error codes.
 *
 * I'm not sure why I need to change their text into better text when they're
 * already giving me text but whatever.
 */
const getSpreadsheetError = (code, displayMsg, lotNumbers, isBin = false) => {
  const lotLabel = isBin ? 'Item' : 'Lot';
  const lotLabelLowerCase = isBin ? 'item' : 'lot';

  switch (code) {
    case '101':
      return {
        title: `Missing ${lotLabel} Title`,
        description: `${lotLabel} titles are required for every item. Please enter a valid title for the following:`
      };
    // This is a breaking error
    case '108':
      return {
        title: `Missing ${lotLabel} Number`,
        description: `${lotLabel} numbers are required for every item. You have ${lotNumbers.length} ${lotLabelLowerCase}(s) without a number. Please correct all to proceed.`
      };
    case '109':
      return {
        title: `Invalid ${lotLabel} Number`,
        description: `Your ${lotLabelLowerCase} number(s) must be 8 characters or less and contain only numerical values. Please correct the following:`
      };
    case '110':
      return {
        title: `Duplicate ${lotLabel} Number`,
        description: `This ${lotLabelLowerCase} number(s) is used multiple times. Please enter a distinct ${lotLabelLowerCase} number for the following:`
      };
    case '112':
      return {
        title: `Previously Deleted ${lotLabel} Number`,
        description: `This ${lotLabelLowerCase} number(s) was used on a previously deleted ${lotLabelLowerCase}. Please enter a new ${lotLabelLowerCase} number for the following:`
      };
    case '118':
      return {
        title: 'Missing Item Price',
        description:
          'Price is required for every item. Please enter a valid price for the following:'
      };
    case '119':
      return {
        title: 'Invalid Item Price',
        description:
          'Item prices must be a positive number. Please enter a valid price for the following:'
      };
    case '120':
      return {
        title: 'Invalid Inventory Number',
        description:
          'Your inventory number(s) must only include alpha-numeric characters and dashes and be 32 characters or less. Please correct the following:'
      };
    case '121':
      return {
        title: 'Duplicate Inventory Number',
        description:
          'Your file contains duplicate inventory numbers. Please enter distinct inventory numbers for the following:'
      };
    case '122':
      return {
        title: 'Invalid Low Estimate',
        description: 'Low estimate must be a positive number. Please correct the following:'
      };
    case '123':
      return {
        title: 'Invalid High Estimate',
        description: 'High estimate must be a positive number. Please correct the following:'
      };
    case '124':
      return {
        title: `Invalid ${isBin ? 'Price' : 'Starting Bid'}`,
        description: `${
          isBin ? 'Price' : 'Starting bid'
        } must be a positive number. Please correct the following:`
      };
    case '126':
      return {
        title: 'Invalid Reserve',
        description: 'Reserve must be a positive number. Please correct the following:'
      };
    case '127':
      return {
        title: 'Low Estimate Higher than High Estimate',
        description:
          'Your low estimate(s) must be lower than your high estimate(s). Please correct the following:'
      };
    // This is a breaking case - we do not go to the table
    case '138':
      return {
        title: 'Incorrect column name(s) found',
        description: 'Please remove the following columns from your spreadsheet and re-upload:'
      };
    // This error code should be 4+ different error codes - instead I had to do magic
    case '142-loEst':
      return {
        title: 'Invalid Low Estimate',
        description:
          'Your low estimate(s) must contain only numerical characters. Please correct the following:'
      };
    case '142-hiEst':
      return {
        title: 'Invalid High Estimate',
        description:
          'Your high estimate(s) must contain only numerical characters. Please correct the following:'
      };
    case '142-reserve':
      return {
        title: 'Invalid Reserve',
        description:
          'Your reserve(s) must contain only numerical characters. Please correct the following:'
      };
    case '142-startingBid':
      return {
        title: `Invalid ${isBin ? 'Price' : 'Starting Bid'}`,
        description: `Your ${
          isBin ? 'price' : 'starting bid'
        }(s) must contain only numerical characters. Please correct the following:`
      };
    case '142-realizedPrice':
      return {
        title: 'Invalid Realized Price',
        description: 'Realized Price must be a positive number. Please correct the following:'
      };
    case '142-Illegal number format':
      return {
        title: 'Invalid Realized Price',
        description: 'Your realized price must only contain numerical characters and must be two decimal points or less. Please correct the following:'
      };
    case '149':
      return {
        title: 'Invalid Lot Number',
        description: 'Lot not found. Please correct the following:'
      };
    case '164':
      return {
        title: `Missing ${lotLabel} Description`,
        description: `${lotLabel} Descriptions are required for every item. Please enter a description for the following:`
      };
    case '165':
      return {
        title: `Character Limit Hit for ${lotLabel} Title`,
        description: `Your ${lotLabelLowerCase} title(s) must be 250 characters or less. Please correct the following:`
      };
    // This is a breaking case - we do not go to the table
    case '166':
      return {
        title: 'Unlabeled column found',
        description:
          'Your file must contain correctly labeled columns. Please remove or name and re-upload'
      };
    case '170':
      return {
        title: 'Shipping Height is Invalid',
        description: 'Height must contain numerical values only. Please correct the following:'
      };
    case '171':
      return {
        title: 'Total Weight is Invalid',
        description: 'Weight must contain numerical values only. Please correct the following:'
      };
    case '172':
      return {
        title: 'Shipping Length is Invalid',
        description: 'Length must contain numerical values only. Please correct the following:'
      };
    case '173':
      return {
        title: 'Shipping Width is Invalid',
        description: 'Width must contain numerical values only. Please correct the following:'
      };
    case '179':
      return {
        title: 'Missing Lot or Inventory Number ',
        description: 'Lot or inventory number is required for every item. You have 1 lot(s) without a number. Please correct all to proceed. If you are uploading items for the Private Label sale preview you only need inventory number. '
      };
    default:
      return {
        title: displayMsg,
        description: lotNumbers
      };
  }
};

export default getSpreadsheetError;
